var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.giftList),function(gift){return _c('GiftCard',{key:gift.userGiftCertificateId,staticClass:"mb-4 pb-4",attrs:{"giftCertificate":gift,"mode":_vm.mode},on:{"add":function($event){return _vm.$emit('reload')}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }